// libraries.
import { Badge, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

// selectors.
import { getPolygonsForCards } from '@domains/save-polygons';

// hooks.
import {
  deselectPolygon,
  getIsHoveredPolygon,
  selectPolygonByPolygonId,
} from '@domains/save-polygons/store/slices/modePolygon.slice';

// components.
import { ButtonDeletePolygon } from './components/ButtonDeletePolygon';
import { PolygonComment } from './components/PolygonComment';

export const CardPolygons = () => {
  const dispatch = useDispatch();
  const listPolygons = useSelector(getPolygonsForCards);
  const hoveredPolygonId = useSelector(getIsHoveredPolygon);

  return (
    <div className="d-flex flex-column gap-2 p-3">
      {listPolygons.map(polygon => {
        const isHovered = polygon.polygon_id === hoveredPolygonId;
        const agent = polygon.updated_by_agent ?? polygon.created_by_agent;
        const isBlocking = polygon.polygon_type === 'blocking';

        // Phase 5 D-14: refuerzo visual para blockings (border-left + subtítulo).
        // Inline style — CardPolygons no usa styled-components y la inyección
        // inline es localmente idiomática (research §Item 4 Pattern A).
        const cardStyle = isBlocking
          ? { borderLeft: '4px solid #DC3545' }
          : undefined;

        return (
          <Card
            key={polygon.polygon_id}
            onMouseEnter={() =>
              dispatch(selectPolygonByPolygonId(polygon.polygon_id))
            }
            onMouseLeave={() => dispatch(deselectPolygon())}
            className={`${isHovered ? 'hovered-card' : ''}`}
            style={cardStyle}
          >
            <Card.Body>
              <div className="d-flex align-items-center gap-2">
                <div className="id-polygon">ID: {polygon.polygon_id}</div>
                {isBlocking && <Badge bg="danger">Bloqueo</Badge>}
              </div>
              <div>{agent}</div>
              {isBlocking && (
                <div style={{ color: '#DC3545', fontSize: '0.85rem' }}>
                  Polígono de bloqueo
                </div>
              )}
              {polygon.showDeleteButton && (
                <ButtonDeletePolygon polygonId={polygon.polygon_id} />
              )}
            </Card.Body>
            <PolygonComment
              comment={polygon.comment}
              polygonId={polygon.polygon_id}
            />
          </Card>
        );
      })}
    </div>
  );
};
